<template>
  <!-- Per-block layout lands on THIS wrapper rather than riding fallthrough onto
       the block component, as it does on the PDP. The wrapper already exists and
       already owns the block's box (`.dk-cartblk { padding-inline: 1.25rem }`),
       and two of the cart blocks are multi-root — `CartCheckoutButton` renders a
       checkout link plus an optional "View cart" — so fallthrough would be
       silently dropped there. Both resolvers return nothing for an untouched
       block, so the rendering is unchanged until a seller opts in. -->
  <div
    v-for="blk in blocks"
    :key="blk.id"
    class="dk-cartblk"
    :class="[`dk-cartblk--${blk.type}`, blockLayoutClass(blk.settings)]"
    :style="blockLayoutStyle(blk.settings)" :data-dk-block="blk.id"
  >
    <component :is="cartBlockRegistry[blk.type]" :settings="blk.settings" />
  </div>
</template>

<script setup lang="ts">
import { blockLayoutClass, blockLayoutStyle } from "@dk/theme"
import { useCartDrawer } from "../../lib/cartdrawer"
import { cartBlockRegistry } from "./registry"

/** The `main-cart` block host, shared by the cart DRAWER and the cart PAGE.
 *
 *  Before this existed the drawer rendered the seller's blocks and `/cart`
 *  hand-rolled a second, divergent layout — so reordering blocks in the builder
 *  changed the drawer and did nothing to the page. There is one source of truth
 *  now; the two hosts differ only in the frame they put around it.
 *
 *  The block LIST itself moved to `useCartBlockHost` once blocks had to know about
 *  each other — `line-items` renders add-on lines only when the `add-ons` block is
 *  absent — and one owner beats two copies of the same resolution. This component
 *  is now purely the markup. */
const { blocks } = useCartDrawer()
</script>
